import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentV2PushContentDetailResponse {
  content_type: number;
  status: number;
  input_text: string;
  content_title: string;
  content_resource?: string;
  template_id: number;
  created_at: number;
  push_at: number;
  visit_at: number;
  user_name: string;
  user_email: string;
  user_id: number;
  produce_count: number;
  push_count: number;
  cover_image_url: string;
  video_url?: string;
};

export class AgentV2PushContentDetailData {
  @Required("Content type cannot be empty")
  @IsNumber("Content type must be a number")
  contentType: number;

  @IsString("Create source must be a string")
  createSource: string;

  // @IsString("File URL must be a string")
  fileUrl: string;

  @IsString("Model must be a string")
  model: string;

  @IsString("Aspect ratio must be a string")
  aspectRatio: string;

  @IsNumber("Duration must be a number")
  duration: number;

  @IsString("Resolution must be a string")
  resolution: string;

  @IsNumber("File count must be a number")
  fileCount: number;

  @Required("Status cannot be empty")
  @IsNumber("Status must be a number")
  status: number;

  // @Required("Input text cannot be empty")
  @IsString("Input text must be a string")
  inputText: string;

  @IsString("Input text must be a string")
  content: string;

  @IsArray("Image URLs must be an array")
  imageUrls: string[];

  @IsString("Audio URL must be a string")
  audioUrl: string;

  // @Required("Content title cannot be empty")
  @IsString("Content title must be a string")
  contentTitle: string;

  // @Required("Content resource cannot be empty")
  @IsString("Content resource must be a string")
  contentResource: string;

  @Required("Template ID cannot be empty")
  @IsNumber("Template ID must be a number")
  templateId: number;

  // @Required("Task ID cannot be empty")
  @IsString("Task ID must be a string")
  taskId?: string;

  @Required("Created at cannot be empty")
  @IsNumber("Created at must be a number")
  createdAt: number;

  @Required("Push at cannot be empty")
  @IsNumber("Push at must be a number")
  pushAt: number;

  @Required("Visit at cannot be empty")
  @IsNumber("Visit at must be a number")
  visitAt: number;

  @Required("User name cannot be empty")
  @IsString("User name must be a string")
  userName: string;

  @Required("User email cannot be empty")
  @IsString("User email must be a string")
  userEmail: string;

  @Required("User ID cannot be empty")
  @IsString("User ID must be a string")
  userId: string;

  @Required("Produce count cannot be empty")
  @IsNumber("Produce count must be a number")
  produceCount: number;

  @Required("Push count cannot be empty")
  @IsNumber("Push count must be a number")
  pushCount: number;

  // @Required("Cover image URL cannot be empty")
  @IsString("Cover image URL must be a string")
  coverImageUrl: string;

  // @Required("Video URL cannot be empty")
  @IsString("Video URL must be a string")
  videoUrl?: string;

  // @Required("User avatar cannot be empty")
  @IsString("User avatar must be a string")
  userAvatar: string;

  @IsString("Summary must be a string")
  summary: string;

  @IsString("Is unusual must be a string")
  isUnusual?: boolean;
}

const transformAndValidateAgent = (
  response: AgentV2PushContentDetailResponse
): AgentV2PushContentDetailData => {
  const transformedData = transformKeys(response);

  try {
    const data = DataValidator.validateOrThrow(transformedData, AgentV2PushContentDetailData);
    switch (data.contentType) {
      case 1:
        if (!data.coverImageUrl || !data.videoUrl) {
          data.isUnusual = true;
        }
        break;
      case 2:
        if (!data.coverImageUrl || !data.audioUrl) {
          data.isUnusual = true;
        }
        break;
      case 3:
        if (!data.userAvatar || !data.imageUrls) {
          data.isUnusual = true;
        }
        break;
      case 4:
        if (!data.contentTitle || !data.imageUrls) {
          data.isUnusual = true;
        }
        break;
      case 5:
        if (!data.contentTitle || !data.coverImageUrl) {
          data.isUnusual = true;
        }
        break;
      default:
        break;
    }
    return data;
  } catch (error) {
    console.error("Agent V2 Push Content Detail data validation failed:", error.message);
    throw error;
  }
};

/** 用户制作内容详情*/
export const agentV2PushContentDetail = async (id: string): Promise<AgentV2PushContentDetailData> => {
  const response = await api.post<AgentV2PushContentDetailResponse>('/agent-v2/push-content-detail', {
    id,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
